export default "__VITE_ASSET__3b2b2271__"